module.exports = __webpack_public_path__ + "img/palm-x6-plus-2.40f31bb6.png";